import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Page } from '../../components/Layout'
import { Login } from '../../components/Login'
import { useAuth } from '../../hooks/useAuth'
import { supabase } from '../../lib/supabase'

// Métricas de funil (Seção 6 do handoff): conversão por etapa.
// Fonte: eventos_funil (staff-only via RLS).
const ETAPAS = ['lead', 'triagem_viavel', 'proposta', 'contrato', 'pago'] as const
const LABEL: Record<string, string> = {
  lead: 'Leads',
  triagem_viavel: 'Triagem viável',
  proposta: 'Proposta',
  contrato: 'Contrato',
  pago: 'Pago',
}

export default function Metricas() {
  const { user, loading } = useAuth()
  const [contagem, setContagem] = useState<Record<string, number>>({})
  const [isStaff, setIsStaff] = useState<boolean | null>(null)

  useEffect(() => {
    if (loading || !user) return
    ;(async () => {
      const { data: perfil } = await supabase.from('perfis').select('papel').eq('user_id', user.id).maybeSingle()
      const staff = perfil?.papel === 'staff'
      setIsStaff(staff)
      if (staff) {
        const { data } = await supabase.from('eventos_funil').select('etapa')
        const c: Record<string, number> = {}
        for (const row of data ?? []) c[(row as { etapa: string }).etapa] = (c[(row as { etapa: string }).etapa] ?? 0) + 1
        setContagem(c)
      }
    })()
  }, [loading, user])

  if (loading) return <Page><p className="text-pfa-slate">Carregando…</p></Page>
  if (!user) return <Page><Login staff /></Page>
  if (isStaff === false) return <Page><div className="card"><p className="text-pfa-slate">Área restrita à equipe.</p></div></Page>

  const base = contagem.lead || 0
  function pct(n: number): string {
    return base ? `${Math.round((n / base) * 100)}%` : '—'
  }

  return (
    <Page>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-pfa-navy">Métricas do funil</h1>
        <Link to="/interno" className="btn-ghost">Fila de casos</Link>
      </div>

      <div className="mt-6 grid gap-4 md:grid-cols-5">
        {ETAPAS.map((e) => (
          <div key={e} className="card text-center">
            <p className="text-xs uppercase tracking-wide text-pfa-slate/70">{LABEL[e]}</p>
            <p className="mt-2 text-3xl font-semibold text-pfa-navy">{contagem[e] ?? 0}</p>
            <p className="mt-1 text-xs text-pfa-coral">{pct(contagem[e] ?? 0)} do topo</p>
          </div>
        ))}
      </div>

      <p className="mt-6 text-xs text-pfa-slate/70">
        Conversão por etapa (base = leads). CAC por canal e tempo de ciclo entram com a instrumentação de Ads e os
        timestamps de status (Fase 2).
      </p>
    </Page>
  )
}
